import { render, staticRenderFns } from "./groupC.vue?vue&type=template&id=2a477618&scoped=true"
import script from "./groupC.vue?vue&type=script&lang=js"
export * from "./groupC.vue?vue&type=script&lang=js"
import style0 from "./groupC.vue?vue&type=style&index=0&id=2a477618&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a477618",
  null
  
)

export default component.exports